import { handleActions } from 'redux-actions';
import {
  setBanderaPrimerPago,
  setContratante,
  setParametrosPago,
} from '../actions/cotizacion.actions';

const initialState = {
  contratantes: [],
  parametrosPago: null,
  // banderaPrimerPago: null,
};

const handleSetContratante = (state, { payload }) => {
  if (!Array.isArray(state.contratantes)) {
    state.contratantes = [];
  }

  const contratantes = state.contratantes.filter(
    (cont) => cont.cotizador !== payload.cotizador,
  );

  contratantes.push(payload);
  state.contratantes = contratantes;

  return { ...state };
};

const handleParametrosContratante = (state, { payload: parametrosPago }) => {
  if (parametrosPago) {
    const { formasPago, banksplazo_msi } = parametrosPago;
    parametrosPago.formasPago = formasPago?.map((e) => ({
      label: e.label,
      value: e,
    }));

    parametrosPago.plazos = banksplazo_msi?.PlazoEntity?.map((plazo) => {
      //NO MODIFICAR ESTE MAPPEO, SI SE CAMBIA ALGO SE DANIA PARA TODOS LOS PRODUCTOS.
      const label = plazo.Name;
      const value = plazo;
      value.label = label;
      return { label, value };
    });

    return { ...state, parametrosPago };
  }
  return { ...state };
};

const handleBanderaPrimerPago = (state, { payload: banderaPrimerPago }) => {
  return { ...state, banderaPrimerPago };
};

const cotizacionReducer = handleActions(
  {
    [setContratante]: handleSetContratante,
    [setParametrosPago]: handleParametrosContratante,
    // [setBanderaPrimerPago]: handleBanderaPrimerPago,
  },
  initialState,
);

export default cotizacionReducer;
